// extracted by mini-css-extract-plugin
export default {"header":"gCeC4","header--show":"oOPU1"};